<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ResultDialog',
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, default: '' },
  },
  emits: ['close'],
  setup(_props: any, { emit }: { emit: (event: string) => void }) {
    const handleClose = () => emit('close');
    return { handleClose };
  },
});
</script>

<template>
  <div class="absolute inset-0 z-70 flex items-start justify-center pointer-events-none">
    <!-- Overlay escuro com fade -->
    <transition name="fade">
      <div
        v-if="show"
        class="absolute inset-0 top-[0px] bg-gray-600 bg-opacity-40 z-60 max-h-[calc(100%-73px)]"
        @click="handleClose"
      ></div>
    </transition>
    <!-- Dialog com slide-up + fade -->
    <transition name="slide-fade" mode="out-in">
      <div
        v-if="show"
        class="absolute left-0 right-0 bottom-0 mx-auto w-full max-h-[60vh] flex flex-col p-4 bg-white shadow-lg rounded-2xl border border-gray-200 z-70 pointer-events-auto"
        style="top: 35vh; bottom: 0"
      >
        <button
          @click="handleClose"
          class="absolute top-2 right-2 text-gray-400 hover:text-purple-600 focus:outline-none"
          aria-label="Fechar"
        >
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h3 class="text-base font-semibold mb-4 text-gray-900">{{ title }}</h3>
        <div class="flex-1 overflow-y-auto text-gray-700 text-sm">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
.slide-fade-enter-to,
.slide-fade-leave {
  opacity: 1;
  transform: translateY(0);
}
</style>
